import { AuthImage } from "@/components/site/AuthImage";
import { fmtDT } from "@/lib/brand";

function Phase({ b, phase, rec }) {
  return (
    <div className="space-y-2" data-testid={`trip-inspection-${phase}-${b.id}`}>
      <p className="text-sm font-semibold">{phase === "pickup" ? "At pickup" : "At return"} <span className="font-normal text-neutral-500">· {fmtDT(rec.at)}</span></p>
      <p className="text-sm text-neutral-600">
        {rec.odometer_km != null && <>Odometer {rec.odometer_km.toLocaleString("en-IN")} km · </>}
        {rec.fuel_pct != null && <>Fuel / charge {rec.fuel_pct}%</>}
      </p>
      {rec.notes && <p className="text-sm text-neutral-600">{rec.notes}</p>}
      <div className="flex flex-wrap gap-2">
        {rec.photos.map((pid) => <AuthImage key={pid} src={`/bookings/${b.id}/inspection-photos/${pid}`} className="h-20 w-28 rounded-lg object-cover" />)}
      </div>
    </div>
  );
}

export function TripInspection({ b }) {
  const ins = b.inspections || {};
  if (!ins.pickup && !ins.return) return null;
  return (
    <div className="space-y-4" data-testid={`trip-inspection-${b.id}`}>
      <p className="text-xs uppercase tracking-wider text-neutral-500">Vehicle inspection records</p>
      {ins.pickup && <Phase b={b} phase="pickup" rec={ins.pickup} />}
      {ins.return && <Phase b={b} phase="return" rec={ins.return} />}
    </div>
  );
}
